import {LearnInstructions} from './LearnInstructions'

export const TypewriterMessage = ({message, children}) => {
  return (
    <div
      style={{
        textAlign: 'center',
        minHeight: 'calc(100vh - 15rem)',
        display: 'grid',
        placeContent: 'center',
      }}
    >
      <LearnInstructions
        levelData={{
          instructions: [message],
        }}
      />
      {children}
    </div>
  )
}
